export const validateEmail = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
export const avaragePassword = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/);
export const strongPassword = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{10,}$/);

export const validateName = new RegExp("^[a-zA-Z ]{3,}$");
export const validateSurname = new RegExp("^[a-zA-Z ]{3,}$");
export const validateCellphoneNumber = new RegExp("^([0]{1}[0-9]{9})$");
export const validateIdNumber = new RegExp("(?<Year>[0-9][0-9])(?<Month>([0][1-9])|([1][0-2]))(?<Day>([0][1-9])|([1-2][0-9])|([3][0-1]))(?<Gender>[0-9])(?<Series>[0-9]{3})(?<Citizenship>[0-9])(?<Uniform>[0-9])(?<Control>[0-9])");
export const validateOTP = new RegExp("^[0-9]{6}$");
export const validateIMEINumber = new RegExp("[1-9][0-9]{9,14}");
